export const normalizeArabic = (text?: string) => {
    if (!text) return text;

    return (
        text
            // Normalize Unicode form
            .normalize("NFKC")

            // Remove tatweel
            .replace(/\u0640/g, "")

            // Normalize common Arabic variants
            .replace(/[إأآٱ]/g, "ا")
            .replace(/ى/g, "ي")
            .replace(/ؤ/g, "و")
            .replace(/ئ/g, "ي")
            .replace(/ة/g, "ة")

            // Remove Arabic presentation forms (CRITICAL)
            .replace(/[\uFB50-\uFDFF\uFE70-\uFEFF]/g, "")
    );
};
